import { useAuthContext } from '../../context/auth.context'

// Whether this session is an impersonation (the access token's
// impersonationEndsAt): content refuses every provisioning write from one
// (auth.impersonation_not_allowed), so the page offers none. Outside an
// AuthProvider (a page rendered on its own) it is not.
export const useImpersonating = () => {
  const auth = useAuthContext()
  const claims = auth && auth.state && auth.state.jwtClaims
  return !!(claims && claims.impersonationEndsAt)
}
